<p-accordionTab>
    <p-header>
      <div class="ui-helper-clearfix">
        <div class="left">
          <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Tow Alarm(AT+GTTOW)</span>
        </div>
      </div>
    </p-header>
    <div class="ui-g">
  
      <div class="ui-g">
        <p-accordionTab [selected]="true">
          <p-header>
            <div class="ui-helper-clearfix">
              <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Basic
                  Settings</span>
              </div>
            </div>
          </p-header>
  
          <div class="row align-items-center">
            <div class="col row dvcFields">
              <div class="col lblStyle">
                <form-input fieldName="Tow Enable">
                </form-input>
              </div>
              <div class="col">
                <p-dropdown [options]="modeOptions" [(ngModel)]="towParameters.modeTow"
                  [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
              </div>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col row dvcFields">
              <div class="col lblStyle">
                <form-input fieldName="Fake Tow Delay">
                </form-input>
              </div>
              <div class="col">
                <div class="ui-inputgroup">
                  <p-spinner step="1" size="2" [(ngModel)]="towParameters.fakeTowDelay" [min]="5"
                    [max]="900">
                  </p-spinner>
                  <span class="ui-inputgroup-addon">0~10</span>
                  <span class="ui-inputgroup-addon">min</span>
                </div>
              </div>
            </div>
          </div>
  
          <div class="row align-items-center">
            <div class="col row dvcFields">
              <div class="col lblStyle">
                <form-input fieldName="Report Interval">
                </form-input>
              </div>
              <div class="col">
                <div class="ui-inputgroup">
                  <p-spinner step="1" size="7" [(ngModel)]="towParameters.towInterval" [min]="0"
                    [max]="10">
                  </p-spinner>
                  <span class="ui-inputgroup-addon">30~96400</span>
                  <span class="ui-inputgroup-addon">s</span>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </div>
  
      <div class="ui-g">
        <p-accordionTab [selected]="true">
          <p-header>
            <div class="ui-helper-clearfix">
              <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Motion Sensor Settings</span>
              </div>
            </div>
          </p-header>
  
          <div class="row mt-3">
            <div class="col row dvcFields">
              <div class="col lblStyle">
                <form-input fieldName="Rest Duration">
                </form-input>
              </div>
              <div class="col">
                <div class="ui-inputgroup">
                  <p-spinner step="1"  size="2" [(ngModel)]="towParameters.restDuration" [min]="1"
                    [max]="255">
                  </p-spinner>
                  <span class="ui-inputgroup-addon">1~255</span>
                  <span class="ui-inputgroup-addon">(x15s)</span>
                </div>
              </div>
            </div>
          </div>
  
          <div class="row align-items-center">
            <div class="col row dvcFields">
              <div class="col lblStyle">
                <form-input fieldName="Motion Duration">
                </form-input>
              </div>
              <div class="col">
                  <p-spinner step="1" size="7" [(ngModel)]="towParameters.motionDuration" [min]="1" [max]="100">
                  </p-spinner>
                  <span class="ui-inputgroup-addon">1~100</span>
                  <span class="ui-inputgroup-addon">(x100ms)</span>
            </div>
              </div>
            </div>
            
        <div class="row align-items-center">
            <div class="col row dvcFields">
              <div class="col lblStyle">
                <form-input fieldName="Motion Threshold">
                </form-input>
              </div>
              <div class="col">
                <div class="ui-inputgroup">
                  <p-spinner step="1" id="duration" size="7" [(ngModel)]="towParameters.motionThreshold" [min]="2"
                    [max]="4">
                  </p-spinner>
                  <span class="ui-inputgroup-addon">2~4</span>
                </div>
              </div>
            </div>
          </div>
  
        </p-accordionTab>
      </div>

  
    </div>
  
  </p-accordionTab>